import { deleteDashboardMutation } from '@akin-home/dashboards/frontend';
import { useMutation, useQueryClient } from 'react-query';
import { dashboard_query_keys } from './query_keys';

export const useDeleteDashboard = () => {
  const query_client = useQueryClient();

  return useMutation(deleteDashboardMutation, {
    onSuccess({ data }) {
      query_client.invalidateQueries(dashboard_query_keys.lists());
      query_client.removeQueries(
        dashboard_query_keys.detail(data.deleteDashboard?.id)
      );
    },
  });
};
